import { Button, Input, ToastMessage } from '@cokitchen/cokitchen-components';
import LocalModal from 'components/base/local-modal';
import SelectDropdown from 'components/base/select-dropdown';
import useProductionReportContext from 'contexts/kitchen/production-report.context/context';
import { CategoryType, MealItemType } from 'models/production-report.model';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { apiService } from 'services/base.service';
import { STORAGE_KEYS } from 'utils/constants';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  meal: MealItemType;
  updateMeals: (data: Partial<MealItemType>) => void;
};
const EditMealModal = ({ isOpen, onClose, meal, updateMeals }: Props) => {
  const { sections } = useProductionReportContext();
  const cokitchenId = localStorage.getItem(STORAGE_KEYS.COKITCHEN);
  const [formData, setFormData] = useState({
    section: meal.section,
    category: meal.category,
    name: meal.kitchen_item.name,
    qty: meal.minimun_stock_level
  });
  const [mealCategories, setMealCategories] = useState<CategoryType[]>([]);
  const [loading, setLoading] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value, name } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleUpdate = async () => {
    const data = {
      id: meal.id,
      minimun_stock_level: formData.qty,
      category: formData.category.name,
      section: formData.section.name
    };
    try {
      setLoading(true);
      const res = await apiService.post(`cokitchen-item/${cokitchenId}/update`, {
        data
      });
      if (res) {
        toast(<ToastMessage type='success' message='Meal updated successfully' />);
        updateMeals({
          id: meal.id,
          category: formData.category,
          category_id: formData.category.id,
          section: formData.section,
          section_id: formData.section.id,
          minimun_stock_level: formData.qty
        });
        onClose();
      }
    } catch (err: any) {
      toast(<ToastMessage type='error' message={err.response.data.message} />);
    } finally {
      setLoading(false);
    }
  };
  const disabled =
    !formData.category.name || !formData.section.name || !formData.name || !formData.qty;

  const fetchMealCategory = async () => {
    if (!formData.section.id) return;
    try {
      const res = await apiService.get(
        `cokitchen-item/cokitchen/${cokitchenId}/sections/${formData.section.id}/categories`
      );
      setMealCategories(res?.data);
    } catch (err: any) {
      toast(<ToastMessage type='error' message={err.response.data.message} />);
    }
  };

  useEffect(() => {
    fetchMealCategory();
  }, [cokitchenId, formData.section.id]);
  return (
    <LocalModal isOpen={isOpen} onRequestClose={onClose} title='Edit Kitchen Item'>
      <div className='w-full'>
        <div className='mt-6'>
          <div className='mb-[28px]'>
            <SelectDropdown
              options={sections?.slice(1)}
              value={formData.section.name}
              placeholder='Type section name'
              setValue={(value) =>
                setFormData({
                  ...formData,
                  section: value,
                  category: { ...formData.category, id: '', name: '' }
                })
              }
              label='Section'
            />
          </div>
          <div className='mb-[28px]'>
            <SelectDropdown
              options={mealCategories}
              value={formData.category.name}
              placeholder='Type category name'
              setValue={(value) => setFormData({ ...formData, category: value })}
              label='Kitchen Item category'
            />
          </div>
          <div className='mb-[28px]'>
            <Input
              design='bordered'
              label='Kitchen Item name'
              value={formData.name}
              disabled={true}
              placeholder='Carb rice & spices'
              name='name'
              onChange={handleChange}
            />
          </div>
          <div className='mb-10 relative'>
            <Input
              design='bordered'
              label='Min. qty'
              placeholder='00'
              name='qty'
              type='tel'
              pattern='[0-9]*'
              value={formData.qty}
              onChange={handleChange}
            />
            <p className='text-sm text-[#96999C] absolute top-[55%] right-4 z-50'>Portion</p>
          </div>
          <div className='flex justify-end w-full'>
            <Button variant='link' color='transparent' className='mr-6' onClick={onClose}>
              Cancel
            </Button>
            <Button
              variant='block'
              color='primary'
              className='w-[139px] h-[41px]'
              onClick={handleUpdate}
              disabled={disabled}
              loading={loading}>
              Update
            </Button>
          </div>
        </div>
      </div>
    </LocalModal>
  );
};

export default EditMealModal;
